import { createSlice } from "@reduxjs/toolkit";

export type AllocationCompliance = {
  filter: {
    commodity: string;
    district: string[] | [];
    baseline: string;
    trendView: string;
    baseSku: string;
  };
  isDownload: boolean;
  isPartnerView: boolean;
  filtersLoaded: boolean;
  dataLoaded: boolean;
  isData: boolean;
};

const initialState: AllocationCompliance = {
  filter: {
    commodity: "",
    district: [],
    baseline: "",
    trendView: "",
    baseSku: "",
  },
  isDownload: false,
  isPartnerView: false,
  filtersLoaded: false,
  dataLoaded: false,
  isData: false,
};

const allocationComplianceSlice = createSlice({
  name: "allocationCompliance",
  initialState,
  reducers: {
    updateAllocationComplianceDetails(state: AllocationCompliance, action) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export const { updateAllocationComplianceDetails } =
  allocationComplianceSlice.actions;
export default allocationComplianceSlice.reducer;
